// extracted by mini-css-extract-plugin
export default {"container":"CloudImageComponent_container__SeaS3","imageWrapper":"CloudImageComponent_imageWrapper__sRxqb","fullImage":"CloudImageComponent_fullImage__NTaBS"};